import { createAsyncActionType } from './index';

export const GET_PROJECT = createAsyncActionType('project', 'GET_PROJECT');
